import { FC } from 'react';
import Typography from '@components/common/typography';
import VerificationCode from '@components/verification_code';
import styles from './styles.module.scss';
import { hidePhoneNumber } from '@utils/index';
import { apiAuthService } from '@api';
import { useApiMutation } from '@hooks/api/useApiMutation';
import { useTranslation } from 'react-i18next';
import { useLocales } from '@hooks/helpers/useLocales';
import { useApiQuery } from '@hooks/api/useApiQuery';
import { IModalComponentProps } from '@context/modal_context';
import { useUserContext } from '@hooks/context/useUserContext';
import illustration from '@svg/illustrations/sms_sent.svg';

const VerificationPhoneUserModal: FC<IModalComponentProps<{ secure_id: string; code: string }>> = ({
    modalData,
    changeModalData
}) => {
    const { t } = useTranslation('modals', {
        keyPrefix: 'verification_phone'
    });
    const { user } = useUserContext();
    const { requestSuccessLocale, requestErrorLocale } = useLocales();

    const { handleRequest: handleResend } = useApiMutation({
        method: () => apiAuthService.sendSecurityCode(),
        onSuccess: (secure_id) => {
            requestSuccessLocale('resent_phone_verification');
            changeModalData({ ...modalData, secure_id, code: '' });
        },
        onError: requestErrorLocale
    });

    useApiQuery({
        method: () => apiAuthService.sendSecurityCode(),
        onSuccess: (secure_id) => {
            changeModalData({ ...modalData, secure_id });
        },
        isInitialRequest: false,
        onError: requestErrorLocale
    });

    return (
        <div className={styles.wrapper}>
            <img src={illustration} alt="sms sent illustration" />
            <Typography variant="h4" className={styles.title}>
                {t('title')}
            </Typography>
            <Typography variant="body3" className={styles.description}>
                {user?.phone_code ? (
                    <>
                        {t('to')}{' '}
                        <b>
                            {user?.phone_code &&
                                (user?.phone_code.includes('+')
                                    ? user?.phone_code
                                    : `+${user?.phone_code}`)}{' '}
                            {hidePhoneNumber(user?.phone_number)}
                        </b>
                    </>
                ) : (
                    t('to_primary')
                )}
            </Typography>
            <div className={styles.content}>
                <VerificationCode
                    onChange={(value) => changeModalData({ ...modalData, code: value })}
                    value={modalData?.code}
                />
                <div>
                    <button onClick={handleResend}>{t('resend')}</button>
                </div>
            </div>
        </div>
    );
};

export default VerificationPhoneUserModal;
